// extracted by mini-css-extract-plugin
export default {"incorrect":"FeedbackQuestionTItle_incorrect__rcNrV","correct":"FeedbackQuestionTItle_correct__86RI5"};